/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {DismissSuggestedActionRequest} from '@cash-web/protos/squareup/cash/cashfrontdoor/api/v1beta1/suggested_actions_messages.pb'
import {DismissSuggestedActionResponse} from '@cash-web/protos/squareup/cash/cashfrontdoor/api/v1beta1/suggested_actions_messages.pb'


export const dismissSuggestedAction = (request: DismissSuggestedActionRequest, options?: CashRequestOptions) => post<DismissSuggestedActionRequest, DismissSuggestedActionResponse>("/cash-app/frontdoor/dismiss-suggested-action", request, {...options, rejectOnError: true })